import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

export default async (emailToken?: string) => {
    const httpRequest = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/password/validate`,
        method: "get",
        headers: { auth: true, "x-mail-token": emailToken },
    });
    const { body, statusCode } = httpRequest;
    const errorFeedBacks = {
        400: "O token informado para recuperação não é válido!",
        401: "Acesso negado!",
        404: "O token informado para recuperação não existe!",
    };

    return handleStatusCases({ body, statusCode, errorFeedBacks });
};
